import React from 'react'

export default function SearchBar(props) {
	return (
		<React.Fragment>
			<div _ngcontent-njs-c67=""  id="searchWrap" class="overlay" style={{ display: 'block' }}>
				<div _ngcontent-njs-c67=""  id="searchPop" class="search-pop">
					<form _ngcontent-njs-c67="" >
						<a _ngcontent-njs-c67="" id="searchBack" class="search-back ui-link" onClick={props.closeSearchbar}  >Back</a>
						<input _ngcontent-njs-c67="" id="searchInput" class="main-input-search" data-role="none" type="text" autocapitalize="off" autocomplete="off" autocorrect="off" placeholder="Search Events" />
						<button _ngcontent-njs-c67=""  id="searchClear" class="search-clear ui-btn ui-shadow ui-corner-all" type="reset">Reset</button>
						<button _ngcontent-njs-c67=""  id="searchBtn" class="search-collapse ui-btn ui-shadow ui-corner-all">Search</button>
					</form>
					<div _ngcontent-njs-c67=""  id="searchResult" class="suggestion-wrap" style={{ display: 'none' }}>
						<dl id="noMatching" class="no-matching" style={{ display: 'none' }}>
							<dt></dt>
							<dd>No events found matching ...</dd>
						</dl>
						<ul _ngcontent-njs-c67=""  id="searchList" style={{ display: 'none' }}>
							<li _ngcontent-njs-c67="" id="resultTemplate" style={{ display: 'none' }}>
								<a _ngcontent-njs-c67="" class="ui-link"><span id="marketTime" class="time"></span></a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}
